import { defineStore } from 'pinia';
export const useAppStore = defineStore('app', {
    state: () => ({
        ready: false,
        user: null,
        farms: [],
        farmsByID: {},
        serversByFarmID: {},
        serversByID: {},
        is_tgApp: false,
        tgInitData: null,
        tgBotId: null
    }),
    getters: {
        getFarmByID: (state) => {
            return (farmID) => state.farms.find((farm) => farm.id === farmID);
        }
    },
    actions: {
        set(data) {
            Object.keys(data).forEach((key) => {
                if (key in this.$state) {
                    this.$state[key] = data[key];
                }
            });
        },
        setServerOnline(serverID, online) {
            for (const farm of this.farms) {
                const server = farm.servers?.find((_server) => _server.id === serverID);
                if (server) {
                    server.online = online;
                    break;
                }
            }
        },
        updateServerStatistics(serverID, statistics) {
            let changed = false;
            for (const farm of this.farms) {
                if (!farm.servers)
                    continue;
                const serverIndex = farm.servers.findIndex((_server) => _server.id === serverID);
                if (serverIndex === -1)
                    continue;
                const server = farm.servers[serverIndex];
                const nextServer = { ...server, statistics };
                farm.servers.splice(serverIndex, 1, nextServer);
                changed = true;
                console.log('Updated server statistics', serverID, statistics);
                break;
            }
            if (changed) {
                this.farms = [...this.farms];
            }
        },
        applyFarmStatisticsBatch(rows) {
            console.log('applyFarmStatisticsBatch', rows);
            let updated = false;
            for (const row of rows) {
                const farmID = Number(row?.farm_id);
                if (Number.isNaN(farmID))
                    continue;
                const farm = this.farms.find((_farm) => _farm.id === farmID);
                console.log('Updating farm', farmID, row.statistics);
                if (!farm)
                    continue;
                farm.statistics = structuredClone(row.statistics);
                updated = true;
            }
            if (updated) {
                this.farms = [...this.farms];
            }
        },
        reset() {
            this.farms = [];
            this.user = null;
            this.farmsByID = {};
            this.serversByFarmID = {};
            this.serversByID = {};
        }
    },
});
